import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LogoImage from '../../../../images/icons/logo.png';
import T from 'i18n-react';
import LinkButton from './LinkButton';
import { PLANS } from '../../routing';

const useStyles = makeStyles((theme) => ({
  containerNoHistories: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 300,
    textAlign: 'center',
  },
  logo: {
    width: 80,
    height: 80,
    margin: '20px 0',
  },
  containerLinkButton: {
    width: '100%',
    textAlign: 'center',
    margin: '20px 0',
  },
}));

const NoContent = ({ descriptionNode }) => {
  const classes = useStyles();
  return (
    <div className={classes.containerNoHistories}>
      <img src={LogoImage} alt="icon" className={classes.logo} />
      {descriptionNode}
      <div className={classes.containerLinkButton}>
        <LinkButton
          variant="contained"
          color="primary"
          disableElevation
          href={PLANS}
        >
          {T.translate('header.plans')}
        </LinkButton>
      </div>
    </div>
  );
};

NoContent.props = {
  descriptionNone: PropTypes.node,
};

export default NoContent;
